import { render } from "./PanelMenuSub.vue?vue&type=template&id=0ff24244"
import script from "./PanelMenuSub.vue?vue&type=script&lang=js"
export * from "./PanelMenuSub.vue?vue&type=script&lang=js"
script.render = render

export default script